import { PermissionDto } from '@/api/generated';

import { RouteEnum } from './Route.model';

export const ROUTES_PERMISSIONS: Record<RouteEnum, PermissionDto[]> = {
  [RouteEnum.ADMINISTRATION]: [],
  [RouteEnum.CALENDAR]: [PermissionDto.MenuCalendar],
  [RouteEnum.CARS]: [PermissionDto.MenuCars],
  [RouteEnum.CARS_DETAILS]: [PermissionDto.MenuCars],
  [RouteEnum.CATALOG]: [PermissionDto.MenuCatalog],
  [RouteEnum.CHATS]: [PermissionDto.MenuChats],
  [RouteEnum.CONTACTS]: [PermissionDto.MenuContacts],
  [RouteEnum.CONTACTS_CREATE]: [PermissionDto.MenuContacts],
  [RouteEnum.CONTACTS_DETAILS]: [PermissionDto.MenuContacts],
  [RouteEnum.CONTACTS_EDIT]: [PermissionDto.MenuContacts],
  [RouteEnum.CUSTOMERS]: [PermissionDto.MenuCustomers],
  [RouteEnum.CUSTOMERS_CREATE_BUSINESS]: [PermissionDto.MenuCustomers],
  [RouteEnum.CUSTOMERS_CREATE_FOREIGN]: [PermissionDto.MenuCustomers],
  [RouteEnum.CUSTOMERS_CREATE_INDIVIDUAL]: [PermissionDto.MenuCustomers],
  [RouteEnum.CUSTOMERS_DETAILS]: [PermissionDto.MenuCustomers],
  [RouteEnum.CUSTOMERS_EDIT]: [PermissionDto.MenuCustomers],
  [RouteEnum.DASHBOARD]: [],
  [RouteEnum.DICTIONARIES]: [PermissionDto.MenuDictionaries],
  [RouteEnum.DISHES]: [PermissionDto.MenuCatalog],
  [RouteEnum.DISHES_DETAILS]: [PermissionDto.MenuCatalog],
  [RouteEnum.DISHES_IMPORT]: [PermissionDto.MenuCatalog],
  [RouteEnum.EMAILS]: [PermissionDto.MenuEmails],
  [RouteEnum.EMERGENCY_CONTACTS]: [PermissionDto.MenuEmergencyContacts],
  [RouteEnum.EMERGENCY_CONTACTS_CREATE]: [PermissionDto.MenuEmergencyContacts],
  [RouteEnum.EMERGENCY_CONTACTS_DETAILS]: [PermissionDto.MenuEmergencyContacts],
  [RouteEnum.EMERGENCY_CONTACTS_EDIT]: [PermissionDto.MenuEmergencyContacts],
  [RouteEnum.FORBIDDEN]: [],
  [RouteEnum.HR]: [PermissionDto.MenuHr],
  [RouteEnum.LOGIN_SUCCESSFUL]: [],
  [RouteEnum.NOT_AUTHORIZED]: [],
  [RouteEnum.NOT_FOUND]: [],
  [RouteEnum.OFFER_ELEMENT_DETAILS]: [PermissionDto.MenuCatalog],
  [RouteEnum.OFFER_ELEMENTS]: [PermissionDto.MenuCatalog],
  [RouteEnum.OFFER_GROUP_DEFINITION_DETAILS]: [PermissionDto.MenuCatalog],
  [RouteEnum.OFFER_GROUP_DEFINITIONS]: [PermissionDto.MenuCatalog],
  [RouteEnum.OFFERS]: [PermissionDto.MenuOffers],
  [RouteEnum.OFFERS_CREATE_PREDEFINED]: [PermissionDto.MenuOffers],
  [RouteEnum.PPTX_IMPORT_DETAILS]: [PermissionDto.MenuCatalog],
  [RouteEnum.PPTX_IMPORTS]: [PermissionDto.MenuCatalog],
  [RouteEnum.PROCESSES]: [PermissionDto.MenuProcesses],
  [RouteEnum.PROCESSES_CREATE]: [PermissionDto.MenuProcesses],
  [RouteEnum.PROCESSES_DETAILS]: [PermissionDto.MenuProcesses],
  [RouteEnum.PROCESSES_DETAILS_MULTI_OFFER]: [PermissionDto.MenuProcesses],
  [RouteEnum.PROCESSES_DETAILS_MULTI_OFFER_CREATE]: [PermissionDto.MenuProcesses],
  [RouteEnum.PROCESSES_DETAILS_OFFER]: [PermissionDto.MenuProcesses],
  [RouteEnum.PROCESSES_DETAILS_OFFER_CREATE]: [PermissionDto.MenuProcesses],
  [RouteEnum.PROCESSES_DETAILS_OFFERS]: [PermissionDto.MenuProcesses],
  [RouteEnum.REPORTS]: [PermissionDto.ViewReports],
  [RouteEnum.ROOT]: [],
  [RouteEnum.SETTLEMENTS]: [PermissionDto.ManageSettlements],
  [RouteEnum.STATISTICS]: [PermissionDto.MenuStatistics],
  [RouteEnum.SUPPLIERS]: [PermissionDto.MenuSuppliers],
  [RouteEnum.SUPPLIERS_DETAILS]: [PermissionDto.MenuSuppliers],
  [RouteEnum.TASK_DETAILS]: [PermissionDto.MenuTasks],
  [RouteEnum.TASKS]: [PermissionDto.MenuTasks],
  [RouteEnum.USERS]: [PermissionDto.MenuUsers],
  [RouteEnum.WAITING_FOR_APPROVAL]: [],
};
